var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrintDetailsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.53125,
    y: 10.125,
    width: 9.9375,
    height: 7.125,
    rx: 1.75,
    stroke: "#13499F",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7188 4.125H13.4688V3.375V2.5C13.4688 1.5335 12.6852 0.75 11.7188 0.75H5.28125C4.31475 0.75 3.53125 1.5335 3.53125 2.5V3.375V4.125H4.28125H12.7188Z",
    stroke: "#13499F",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.34375 7.125H6.15625",
    stroke: "#13499F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5938 3.84375H2.40625C1.11183 3.84375 0.0625 4.89308 0.0625 6.1875V12.75C0.0625 14.0444 1.11183 15.0938 2.40625 15.0938H2.875V13.6875H2.40625C1.88848 13.6875 1.46875 13.2678 1.46875 12.75V6.1875C1.46875 5.66973 1.88848 5.25 2.40625 5.25H14.5938C15.1115 5.25 15.5312 5.66973 15.5312 6.1875V12.75C15.5312 13.2678 15.1115 13.6875 14.5938 13.6875H14.125V15.0938H14.5938C15.8882 15.0938 16.9375 14.0444 16.9375 12.75V6.1875C16.9375 4.89308 15.8882 3.84375 14.5938 3.84375Z",
    fill: "#13499F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintDetailsIcon);
export default __webpack_public_path__ + "static/media/PrintDetailsIcon.7f7af0cbce9c1014d2c2dfa6d0592cff.svg";
export { ForwardRef as ReactComponent };